<!--
@Author: Calvin Green <calvin>
@Date:   2021-12-22T11:46:53+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T10:29:42+02:00
@Copyright: Diversitude 2021
-->

<template>
    <div v-if="hasMounted">
        
        <div v-if="type == null && canShowHeader" class="document__head">
                <!--<div v-html="header_html"></div>-->
                <div>
                    <!-- //* ------------------------------ -->
                    <table style="width: 100%;">
                        <tr>
                            <td colspan="2" style="width: 50%;">
                                <img :src="header_details.company_logo" alt="Company Logo" height="100"/>
                            </td>
                            <td colspan="2" style="width: 50%; text-align: center;" >
                                <span style="font-size: 2rem;color: red;">
                                    {{this.header_details.doc_heading}}</span>
                            </td>
                        </tr>

                        <tr class="bold-text">
                            <td colspan="4">{{this.header_details.doc_name}}</td>
                        </tr>

                        <tr class="bold-text">
                            <td colspan="3" style="">{{this.header_details.doc_description}}</td>
                            <td colspan="1" style=""></td>
                        </tr>

                        <tr class="bold-text">
                            <td style="" >SOP No:</td>
                            <td style="" >{{this.header_details.sop_number}}</td>
                            <td style="" >Effective Date</td>
                            <td style="" >{{this.header_details.effective_date}}</td>
                        </tr>

                        <tr class="bold-text">
                            <td style="" >Revision No:</td>
                            <td style="" >{{this.header_details.revision_number}}</td>
                            <td style="" >Supersedes</td>
                            <td style="" >{{this.header_details.supersedes}}</td>
                        </tr>

                        <tr class="bold-text">
                            <td style="" >Revise By</td>
                            <td style="" >{{this.header_details.revise_by_date}}</td>
                        </tr>
                    </table>
                    <!-- //* ------------------------------ -->
                </div>
            </div>
        <div class="document-editor" style="margin-top: 15px;" v-show="type != null">
            <ckeditor v-model="content" :config="editorConfig" :read-only="isReadOnly" @ready="onEditorReady"></ckeditor>
        </div>
        <div class="document-editor" style="margin-top: 15px;" v-show="type == null && isPublished">
                <annotate-pdf
                    v-if="b64 != null"
                    @toggleSignMode="toggleSignMode"
                    :sign_mode="false"
                    :signature_svg="client_signatures"
                    :base64="b64"/>
                    <b-alert v-else show>Waiting for document data</b-alert>
        </div>
        <div class="document-editor" style="margin-top: 15px;" v-show="type == null && !isPublished">
            <b-alert show>This revision is currently unpublished</b-alert>
            <div v-html="content"></div>
        </div>
        <!-- <div>
            <b-button v-if="type != null" @click="sendDataToParent" style="float: right;" class="mt-2 me-auto" variant="primary">
                <i class="fas fa-save me-2"></i>
                <strong>
                    Apply Changes
                </strong>
            </b-button>
        </div> -->
        <SignatureModal v-if="show_signature_modal" />
    </div>
</template>

<script>
import SignatureModal from '@/components/widgets/misc/signingModal.vue'
import Swal from 'sweetalert2'
import { header_data } from './header.js'
import { sopAdminMethods, userMethods, userState } from '@/state/helpers'
//import DecoupledEditor from "@/plugin/ckeditor-custom/ckeditor.js"
import CKEditor from 'ckeditor4-vue';
//import PageBreakPlugin from '@/plugin/pagebreakplugin.js'
//import VuePdfEmbed from '../../../../node_modules/vue-pdf-embed/dist/vue2-pdf-embed'
export default {
    data:() => ({
        show_signature_modal: false,
        show_pdf_wrapper: false,
        sign_mode: true,
        debug_size:'',
        pause_event: false,
        doc_heading: 'Frogs',
        header_table:'',
        editor: null,
        hasMounted: false,
        //isReadOnly: false,
        content:'<h1>Hello world</h1>',
        editorConfig: {
            contentsCss: '/css/ckcustom.css',
            height: '55vh',
            on: {
                instanceReady: function (event) {
                    let dataProcessor = event.editor.dataProcessor;
                    let htmlFilter = dataProcessor && dataProcessor.htmlFilter;

                    if (htmlFilter) {
                        htmlFilter.addRules({
                            elements: {
                                p: function (element) {
                                    let style = element.attributes.style;
                                    // Ensure style attribute exists before attempting to modify it
                                    if (style) {
                                        style = style.replace(/font-family:.*?;/g, 'font-family: \'Open Sans\',\'sans-serif\';');
                                        element.attributes.style = style;
                                    }
                                    return element;
                                },
                            },
                        });
                    }
                },
            },
            extraPlugins: 'dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,clipboard,button,tableresize,panelbutton,panel,floatpanel,colorbutton,colordialog,menu,contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup,filebrowser,find,fakeobjects,floatingspace,listblock,richcombo,font,format,forms,horizontalrule,htmlwriter,iframe,image,indent,indentblock,indentlist,justify,link,list,liststyle,magicline,maximize,newpage,pagebreak,pastefromword,pastetext,preview,removeformat,resize,save,menubutton,scayt,selectall,showblocks,showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,tabletools,templates,toolbar,undo,wysiwygarea',
        }
    }),
    components: {
        ckeditor: CKEditor.component,
        SignatureModal,
        //VuePdfEmbed,
    },
    props:{
        text:{
            required: false,
            default:function(){
                return '';
            }
        },
        readOnly:{
            default:function(){
                return false;
            }
        },
        isPublished: {
            required: true
        },
        type:{},
        revision:{},
        b64:{
            default: null,
        }
    },
    watch:{
        text(newValue){
            if( newValue != null){
                this.pause_event = true;
                this.$nextTick(()=>{
                    //this.editor.setData(newValue);
                    this.content = newValue;
                    //set document to read only if displaying full document
                    //this.isReadOnly = (this.type == null ? true : false);

                    this.$nextTick(()=>{
                        this.pause_event = false;
                    })
                })
            }
        },
        b64(){
            this.show_pdf_wrapper = false;
            this.$nextTick(()=>{
                this.show_pdf_wrapper = true;
            })
        }
    },
    computed:{
        ...userState,
        canShowHeader() {
            if(this.revision == undefined){
                return false;
            }
            else{
                return true;
            }
        },
        header_details() {
            let data = {};
            if(this.revision){
                data = this.revision.header_config;
            }
            else{
                data = {
                    doc_heading: '',
                    doc_name: '',
                    doc_description: '',
                    sop_number: '',
                    revision_number: '',
                    revise_by_date: '',
                    effective_date: '',
                    supersedes: '',
                    company_logo: '',
                }
            }
            return data;

        },
        header_html() {
            return `<table style="width: 100%;">
            <tr>
                <td colspan="2" style="width: 50%;">
                    <img :src="${this.header_details.company_logo}" alt="Company Logo" height="100"/>
                </td>
                <td colspan="2" style="width: 50%; text-align: center;" >
                    <span style="font-size: 2rem;color: red;">
                        ${this.header_details.doc_heading}</span>
                </td>
            </tr>

            <tr class="bold-text">
                <td colspan="4">${this.header_details.doc_name}</td>
            </tr>

            <tr class="bold-text">
                <td colspan="3" style="">${this.header_details.doc_description}</td>
                <td colspan="1" style="">Page x of x</td>
            </tr>

            <tr class="bold-text">
                <td style="" >SOP No:</td>
                <td style="" >${this.header_details.sop_number}</td>
                <td style="" >Effective Date</td>
                <td style="" >${this.header_details.effective_date}</td>
            </tr>

            <tr class="bold-text">
                <td style="" >Revision No:</td>
                <td style="" >${this.header_details.revision_number}</td>
                <td style="" >Supersedes</td>
                <td style="" >${this.header_details.supersedes}</td>
            </tr>

            <tr class="bold-text">
                <td style="" >Revise By</td>
                <td style="" >${this.header_details.revise_by_date}</td>
            </tr>
        </table>`
        },
        isReadOnly() {
            return this.type == null ? true : false;
        },
        client_signatures(){
            let signatures = {
                signature: null,
                initial: null,

            }
            if(this.client_signature != null){
                signatures.signature = this.client_signature.signature_svg;
            }
            if(this.client_initial != null){
                signatures.initial = this.client_initial.signature_svg;
            }
            console.table(signatures);
            return signatures;
        }
    },
    methods:{
        ...userMethods,
        ...sopAdminMethods,
        insertMergeKey(text){
            if(this.type != null){
                this.editor.insertText(text);
            }
            else{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'lightBlue',
                    icon: 'info',
                    title:'Select a section to insert merge keys',
                    customClass: {     popup: 'info-toast' },
                    showConfirmButton: false,
                    timer: 3000, timerProgressBar: true
                });
            }
        },
        onEditorReady(editor) {
            this.editor = editor;
            let previousData = this.content;
            editor.on('blur', function() {
                const currentData = this.content;
                if (currentData !== previousData) {
                    this.sendDataToParent(currentData);
                    previousData = currentData;
                }
            }.bind(this));
        },
        getEditorContentHeight(){
            let editor = this.editor;
            var doc = editor.document.$;
            var height = doc.body.scrollHeight;
            return parseInt(height);
        },
        initEditor(){
            //this.isReadOnly = (this.type == null ? true : false);
            this.content = this.text;
        },
        sendDataToParent(content){
            //let text = this.editor.getData();
            //let text = this.content;
            let height = this.getEditorContentHeight();
            this.$emit('updatedSection', {text: content, height: height});
        },
        toggleSignMode(){
            this.sign_mode = !this.sign_mode;
            this.show_pdf_wrapper = false;
            this.$nextTick(()=>{
                this.show_pdf_wrapper = true;
            })
        },
        showSigningPadModal(){
            this.show_signature_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('signatureModal')
            })
        }
    },
    mounted(){
        //this.$eventHub.$on('forceSaveSection', this.sopAdminMethods)
        window.inst = this;

        //this.content = this.text;
        this.hasMounted = true;
        this.$nextTick(()=>{
            this.initEditor();
        });

        this.header_table = header_data;

        this.$eventHub.$on('insertMergeKey', this.insertMergeKey);
        if(this.client_signature == null){
            this.loadClientSignature('signature');
        }
        if(this.client_initial == null){
            this.loadClientSignature('initial');
        }
    },
    beforeDestroy(){
        window.inst = null;
        //this.clearSopStore();
        this.$eventHub.$off('insertMergeKey');
    }
}
</script>
<style lang="scss">
@for $i from 1 through 100 {
  ol[start="#{$i}"] {
    counter-reset: lis $i !important;
  }
}
</style>
<style scoped>
::v-deep ol {
    list-style-type: none !important;
}

::v-deep li ol {
  counter-reset: lis !important;
}

::v-deep li {
    counter-increment: lis !important;
}

::v-deep li::before {
    content: counters(lis, ".") ". " !important;
}

::v-deep li li::before {
    content: counters(lis, ".") " " !important;
}

/* header stuff */
table, th, td {
    border: 1px solid black;
  }
  #table.tableT{
    width: 100%;
}

</style>
